<template>
  <h3 class="em-h3" :class="{'bold': bold, 'regular': !bold}">
    <slot />
  </h3>
</template>
<script setup>
defineProps({
  bold: {
    type: Boolean,
    default: false
  }
})
</script>
<style lang="scss" scoped>
  .em-h3{
    font-size: 24px;
    letter-spacing: -0.7px;
    line-height: 40px;
  }
</style>
